import type { SentenceLines } from "../content/chinese/sentence-lines.js";

/** Render generated script variants while preserving the reviewed English text. */
export function supportedText(
  form: HTMLFormElement,
  target: HTMLElement,
  text: string,
): void {
  const readings = JSON.parse(form.dataset["cbYufaReadings"] ?? "{}") as Record<
    string,
    SentenceLines
  >;
  const nodes = text.split(/(\p{Script=Han}+)/gu).flatMap((part): Node[] => {
    if (!/\p{Script=Han}/u.test(part)) {
      return [document.createTextNode(part)];
    }
    const lines = readings[part]?.lines;
    if (lines === undefined) {
      const span = document.createElement("span");
      span.lang = "zh";
      span.textContent = part;
      return [span];
    }
    return lines.map((line) => {
      const span = document.createElement("span");
      span.lang = line.hanzi.lang;
      span.dataset["cbWriting"] = line.writing;
      span.className = "hanzi";
      span.textContent = line.hanzi.text;
      return span;
    });
  });
  target.replaceChildren(...nodes);
}
